import Vue from 'vue'

// import format from 'date-fns/format'
// 自定义过滤器
Vue.filter('date-format', function (value, formatStr = 'YYYY-MM-DD HH:mm:ss') {
    // return moment(value).format(formatStr)
    return format(value, formatStr)
});

// 申请人类型
export function typeSqr(value) {
    switch (value) {
        case '1':
            return '申请人'
        case '2':
            return '律师'
        case '3':
            return '其他代理人'
    }
}

//退保-是否全额退保 1是0不是
export function typeTBIsqe(value) {
    switch (value) {
        case '0': return '不是'
        case '1': return '是'
        default: return '不是';
    }
}

//101000 人员类型
export function typeRylx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '自然人';
        case '2':
            return '法人';
        case '3':
            return '非法人组织';
    }
}

// 102000	当事人及主要涉案人类型
export function typeDsrjzysarlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '当事人';
        case '2':
            return '法定代理人';
        case '3':
            return '代理人';
        case '4':
            return '辩护人';
        case '5':
            return '法定代表人';
        case '6':
            return '负责人';
        case '7':
            return '诉讼代表人';
        case '8':
            return '证人';
        case '9':
            return '鉴定人';
        case '10':
            return '有专门知识的人';
        case '11':
            return '翻译人员';
        case '12':
            return '勘验人员';
        case '13':
            return '参与分配申请人';
        case '14':
            return '担保人';
        case '15':
            return '协助执行义务人';
        case '16':
            return '到期债权债务人';
        case '17':
            return '直接责任人';
        case '18':
            return '利害关系人';
        case '19':
            return '被害人';
        case '255':
            return '其他';
    }
}

//103000	代理人类型
export function typeDlrlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '执业律师';
        case '2':
            return '基层法律服务工作者';
        case '3':
            return '当事人的近亲属或工作人员';
        case '4':
            return '当事人所在社区、单位以及有关社会团体推荐的公民';
        case '5':
            return '经赔偿委员会许可的其他公民';
    }
}

//104000	辩护人类型
export function typeBhrlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '执业律师';
        case '2':
            return '人民团体或者被告人所在单位推荐的人';
        case '3':
            return '被告人的监护人、亲友';
    }
}

// 105000	身份证件类型
export function typeSfzjlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '居民身份证';
        case '2':
            return '中国公民护照';
        case '3':
            return '台湾居民来往大陆通行证';
        case '4':
            return '港澳居民来往内地通行证';
        case '5':
            return '外国公民护照';
        case '6':
            return '户口簿';
        case '7':
            return '社会统一信用代码证';
        case '8':
            return '机动车驾驶证';
        case '9':
            return '军警证件';
        case '255':
            return '其他';
    }
}

// 106000	行为能力状况
export function typeXwnlzg(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '完全行为能力';
        case '2':
            return '限制行为能力';
        case '3':
            return '无行为能力';
    }
}

// 107000	刑事责任能力
export function typeXszrnl(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '完全刑事责任能力';
        case '2':
            return '限制刑事责任能力';
        case '3':
            return '无刑事责任能力';
    }
}

// 108000	工作单位类型
export function typeGzdwlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '机关';
        case '2':
            return '事业单位';
        case '3':
            return '企业';
        case '4':
            return '社会团体';
        case '5':
            return '民办非企业单位';
        case '255':
            return '其他';
    }
}

// 109000	证照类型
export function  typeZzlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '营业执照';
        case '2':
            return '组织机构代码证';
        case '3':
            return '事业法人登记证';
        case '4':
            return '统一社会信用代码证';
        case '255':
            return '其他';
    }
}

// 110000	性别
export function typeXb(value) {
    value = String(value);
    switch (value) {
        case '0':
            return '未知的性别';
        case '1':
            return '男性';
        case '2':
            return '女性';
        case '9':
            return '未说明的性别';
    }
}

// 111000	婚姻状况
export function typeHyzk(value) {
    value = String(value);
    switch (value) {
        case '10':
            return '未婚';
        case '20':
            return '已婚';
        case '21':
            return '初婚';
        case '22':
            return '再婚';
        case '23':
            return '复婚';
        case '30':
            return '丧偶';
        case '40':
            return '离婚';
        case '90':
            return '未说明的婚姻状况';
    }
}

// 112000	财产类型
export function typeCclx(value) {
    value = Number(value);
    var dic_cclx={
        1:'货币现金',
        2:'存款',
        3:'交通运输工具',
        4:'房产',
        5:'土地使用权',
        6:'股票',
        7:'基金',
        8:'债券',
        9:'股权',
        10:'债权',
        11:'机器设备',
        12:'产品、原材料',
        13:'知识产权',
        14:'古玩字画',
        15:'森林、林木所有权',
        16:'集体土地所有权',
        17:'珠宝玉石首饰',
        18:'探矿、采矿权',
        19:'船舶',
        20:'船载货物',
        21:'船用燃料',
        22:'船用物料',
        23:'留置的货物',
        255:'其他',
    };
    return dic_cclx[value];
}

// 担保信息财产类型
export function dbxxcclxType(value){
    value = String(value);
    switch (value) {
        case '4':
            return '房产';
        case '5':
            return '土地';
        case '6':
            return '车辆';
        case '7':
            return '机械设备';
        case '8':
            return '现金';
        case '9':
            return '存款';
    }
}


// 301250	非诉行为保全审查-行为保全事项
export function typeXwbqsx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '中止支付信用证项下款项';
        case '2':
            return '中止支付保函项下款项';
        case '3':
            return '停止侵犯知识产权';
        case '4':
            return '海事强制令';
        case '5':
            return '申请责令被申请人作出一定行为';
        case '255':
            return '其他';
    }
}

// 设定抵押设定质押 502002
export function typeSddy(value) {
    value = String(value);
    switch (value) {
        case '4':
            return '房产';
        case '5':
            return '土地';
        case '6':
            return '车辆';
        case '7':
            return '机械设备';
        case '8':
            return '现金';
        case '9':
            return '存款';
    }
}

// 车辆类型
export function typeCar(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '新能源汽车';
        case '2':
            return '微型汽车';
        case '3':
            return '小型汽车';
        case '4':
            return '紧凑型汽车';
        case '5':
            return '中型汽车';
        case '6':
            return '中大型汽车';
        case '7':
            return '大型汽车';
        case '8':
            return 'SUV';
        case '9':
            return 'MPV';
        case '10':
            return '跑车';
        case '255':
            return '其他';
        default:
            return ''
    }
}

/*// 单位类型
export function typeCar(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '新能源汽车';
        case '2':
            return '微型汽车';
        case '3':
            return '小型汽车';
        case '4':
            return '紧凑型汽车';
        case '5':
            return '中型汽车';
        case '6':
            return '中大型汽车';
        case '7':
            return '大型汽车';
        case '8':
            return 'SUV';
        case '9':
            return 'MPV';
        case '10':
            return '跑车';
        case '255':
            return '其他';
    }
}*/

// 113000	材料类型
export function typeCllx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请书';
        case '2':
            return '起诉状';
        case '3':
            return '身份证明';
        case '4':
            return '担保类';
        case '5':
            return '证据类';
        case '6':
            return '立案受理通知书';
        case '255':
            return '其他';
    }
}

// 114000	申请类型
export function typeSqlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '新增申请';
        case '2':
            return '变更申请';
        case '3':
            return '补充申请';
        case '4':
            return '补充材料';
        case '5':
            return '解除申请';
        case '6':
            return '续行申请';
    }
}

// 115000	缴费类型
export function typeJflx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '案件受理费';
        case '2':
            return '申请费';
        case '255':
            return '其他';
    }
}

export function typeJfzt(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '已交费';
        case '2':
            return '待交费';
        case '3':
            return '未交费';
        default: return '--'
    }
}

// 128000	审核结果
export function typeShjg(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '通过';
        case '2':
            return '审核不通过';
        case '3':
            return '退回';
        default:
            return '审核中'
    }
}

// 补退类型
export function typeBtlx(value) {
    switch (value) {
        case 0:
            return '不涉及';
        case 1:
            return '补缴';
        case 2:
            return '退费';
        default:
            return '--'
    }
}

export function typeShjg2(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '通过';
        case '2':
            return '审核不通过';
        case '3':
            return '退回';
        default:
            return '审核中'
    }
}

// 续行保全审核结果
export function typeXxbqShjg(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '同意';
        case '2':
            return '不通过';
        default: return ''
    }
}

// 117000	银联Code值
export function typeYlcode(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '银联';
        case '2':
            return '建设银行';
        case '3':
            return '支付宝';
        case '4':
            return '微信';
        case '5':
            return '银联';
        case '6':
            return '赞同';
        case '7':
            return '河北农行';
        case '8':
            return '通达海';
        case '9':
            return '中国银行';
        case '10':
            return '银联扫码';
        case '11':
            return '工商银行';
        case '12':
            return '邮政支付';
        case '13':
            return '兴业银行';
        case '14':
            return '建设银行';
        case '15':
            return '河北银行';
        case '16':
            return '移动支付';
        case '17':
            return '聚合支付';
    }
}

// 118000	提交人类型
export function typeTjrlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请人';
        case '2':
            return '律师';
        case '3':
            return '其他代理人';
    }
}

// 119000	币种
export function typeBz(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '人民币';
        case '2':
            return '港币';
        case '3':
            return '美元';
        case '4':
            return '英镑';
        case '5':
            return '欧元';
    }
}

//省份
export function typeSF(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '北京';
        case '51':
            return '天津';
        case '100':
            return '河北';
        case '300':
            return '山西';
        case '451':
            return '内蒙古';
        case '600':
            return '辽宁';
        case '750':
            return '吉林';
        case '850':
            return '黑龙江';
        case '1100':
            return '上海';
        case '1150':
            return '江苏';
        case '1300':
            return '浙江';
        case '1451':
            return '安徽';
        case '1600':
            return '福建';
        case '1700':
            return '江西';
        case '1850':
            return '山东';
        case '2050':
            return '河南';
        case '2250':
            return '湖北';
        case '2400':
            return '湖南';
        case '2550':
            return '广东';
        case '2750':
            return '广西';
        case '2900':
            return '海南';
        case '2950':
            return '重庆';
        case '3000':
            return '四川';
        case '3250':
            return '贵州';
        case '3350':
            return '云南';
        case '3500':
            return '西藏';
        case '3600':
            return '陕西';
        case '3750':
            return '甘肃';
        case '3900':
            return '青海';
        case '4000':
            return '宁夏';
        case '4050':
            return '新疆';
    }
}

// 120000	民族
export function typeMz(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '汉族';
        case '2':
            return '蒙古族';
        case '3':
            return '回族';
        case '4':
            return '藏族';
        case '5':
            return '维吾尔族';
        case '6':
            return '苗族';
        case '7':
            return '彝族';
        case '8':
            return '壮族';
        case '9':
            return '布依族';
        case '10':
            return '朝鲜族';
        case '11':
            return '满族';
        case '12':
            return '侗族';
        case '13':
            return '瑶族';
        case '14':
            return '白族';
        case '15':
            return '土家族';
        case '16':
            return '哈尼族';
        case '17':
            return '哈萨克族';
        case '18':
            return '傣族';
        case '19':
            return '黎族';
        case '20':
            return '傈僳族';
        case '21':
            return '佤族';
        case '22':
            return '畲族';
        case '23':
            return '高山族';
        case '24':
            return '拉祜族';
        case '25':
            return '水族';
        case '26':
            return '东乡族';
        case '27':
            return '纳西族';
        case '28':
            return '景颇族';
        case '29':
            return '柯尔克孜族';
        case '30':
            return '土族';
        case '31':
            return '达斡尔族';
        case '32':
            return '仫佬族';
        case '33':
            return '羌族';
        case '34':
            return '布朗族';
        case '35':
            return '撒拉族';
        case '36':
            return '毛难族';
        case '37':
            return '仡佬族';
        case '38':
            return '锡伯族';
        case '39':
            return '阿昌族';
        case '40':
            return '普米族';
        case '41':
            return '塔吉克族';
        case '42':
            return '怒族';
        case '43':
            return '乌孜别克族';
        case '44':
            return '俄罗斯族';
        case '45':
            return '鄂温克族';
        case '46':
            return '德昂族';
        case '47':
            return '保安族';
        case '48':
            return '裕固族';
        case '49':
            return '京族';
        case '50':
            return '塔塔尔族';
        case '51':
            return '独龙族';
        case '52':
            return '鄂伦春族';
        case '53':
            return '赫哲族';
        case '54':
            return '门巴族';
        case '55':
            return '珞巴族';
        case '56':
            return '基诺族';
    }
}

// 121000	案件类型
export function typeAjlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '刑事';
        case '2':
            return '民事';
        case '6':
            return '行政';
    }
}

// 122000	用戶來源
export function typeYhly(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '互联网';
        case '2':
            return '小程序';
    }
}

// 123000	后台用户角色
export function typeHtyhjs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '系统管理员';
        case '2':
            return '超级管理员';
    }
}

// 201000	担保事由
export function typeDbsy(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '财产保全';
        case '2':
            return '证据保全';
        case '3':
            return '行为保全';
        case '4':
            return '先予执行';
        case '5':
            return '设立海事赔偿责任限制基金';
        case '6':
            return '停止执行';
        case '7':
            return '继续执行';
        case '8':
            return '暂缓执行';
        case '255':
            return '其他';
    }
}

// 202000	担保方式
export function typeDbfs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '交纳保证金';
        case '2':
            return '提供保证人';
        case '3':
            return '设定抵押';
        case '4':
            return '设定质押';
        case '5':
            return '保险公司诉责险';
    }
}

// 203000	担保财产保全措施
export function typeDbccbqcs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '查封';
        case '2':
            return '扣押';
        case '3':
            return '冻结';
        case '255':
            return '其他';
    }
}

// 204000	担保变更事项
export function typeDbbgsx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请减少担保';
        case '2':
            return '申请变更担保';
        case '3':
            return '申请取消担保';
    }
}

// 205000	担保审查意见
export function typeDbscyj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '同意';
        case '2':
            return '不同意';
    }
}

// 206000	担保状态
export function typeDbzt(value,nSfbgwc) {
    value = String(value);
    switch (value) {
        case '1':
            return '待提交'
        case '2':
            return '待审核'
        case '3':
            return '待交费'
        case '4':
            return '待出函'
        case '5':
            return nSfbgwc===1?'变更后已出函':'已出函'
        case '6':
            return '审核不通过'
        case '7':
            return '已取消'
        case '8':
            return '退保中'
        case '9':
            return '已退保'
        case '11':
            return '变更待审核'
        case '12':
            return '变更待出函'
    }
}

// 301000	诉讼保全类型
export function typeSsbqlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '财产保全';
        case '2':
            return '证据保全';
        case '3':
            return '行为保全';
        default:
            return ''
    }
}

// 301100	非诉财产-保全审查案件

// 301110	非诉财产-非诉期间
export function typeFsccFsqj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '未起诉或提起仲裁前';
        case '2':
            return '仲裁审理期间';
        case '3':
            return '上诉后二审法院接收移送案件前';
        case '4':
            return '法律文书生效后进入执行程序前';
        case '5':
            return '外国法院审理期间';
        case '6':
            return '申请认可与执行香港特区法院裁判或仲裁裁决受理前';
        case '7':
            return '申请认可与执行澳门特区法院裁判或仲裁裁决受理前';
        case '8':
            return '申请认可与执行台湾地区法院裁判或仲裁裁决受理前';
        case '255':
            return '其他非诉期间';
    }
}

//裁定结果
export function typeCdjg(value, cdjg) {
    /** 保全类别-保全类行-裁定结果
     *
     *  保全类别：1 诉前 2 诉讼
     *  保全类型：1 财产 2 证据 3 行为
     *
     * */
    switch (value) {
        case '1_1_1':
        case '4_1_1':
            return '裁定保全';
        case '1_1_2':
        case '4_1_2':
            return '裁定驳回申请';


        case '2_1_1':
            return '裁定保全财产';
        case '2_1_5':
            return '裁定驳回申请';
        case '2_1_6':
            return '准予撤回申请';
        case '2_1_255':
            return '其他';

        case '1_3_1':
        case '4_3_1':
            return '裁定责令作出一定行为';
        case '1_3_2':
        case '4_3_2':
            return '裁定禁止作出一定行为';
        case '1_3_3':
        case '4_3_3':
            return '裁定驳回申请';

        case '2_3_3':
            return '裁定责令被申请人作出特定行为';
        case '2_3_4':
            return '裁定禁止被申请人作出特定行为';
        case '2_3_5':
            return '裁定驳回申请';
        case '2_3_6':
            return '准予撤回申请';
        case '2_3_255':
            return '其他';

        case '1_2_1':
        case '4_2_1':
            return '裁定保全';
        case '1_2_2':
        case '4_2_2':
            return '裁定驳回申请';

        case '2_2_2':
            return '裁定保全证据';
        case '2_2_5':
            return '裁定驳回申请';
        case '2_2_6':
            return '准予撤回申请';
        case '2_2_255':
            return '其他';

        default: return cdjg
    }
}

// 301120	非诉财产-保全审查意见
export function typeFsccBqscyj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '裁定保全';
        case '2':
            return '裁定驳回申请';
    }
}

// 301130	非诉财产-保全结案方式（裁定结果）
export function typeFsccBqjafs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '转为其他案件中的保全';
        case '2':
            return '准予撤回申请';
        case '3':
            return '按撤回申请处理';
        case '4':
            return '裁定驳回申请';
        case '5':
            return '解除非诉保全';
        case '255':
            return '其他';
    }
}

// 301140	非诉财产-当事人案件地位
export function typeFsccDsrajdw(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请人';
        case '2':
            return '被申请人';
    }
}

// 301210	非诉行为保全审查-非诉期间
export function typeFsxwbqscFsqj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '未起诉或提起仲裁前';
        case '2':
            return '仲裁审理期间';
        case '3':
            return '外国法院审理案件期间';
    }
}

// 301220	非诉行为保全审查-审查意见
export function typeFsxwbqscScyj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '裁定责令作出一定作为';
        case '2':
            return '裁定禁止作出一定行为';
        case '3':
            return '裁定驳回申请';
    }
}

// 301230	非诉行为保全审查-结案方式（裁定结果）
export function typeFsxwbqscJafs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '转为其他案件中的保全';
        case '2':
            return '准予撤回申请';
        case '3':
            return '按撤回申请处理';
        case '4':
            return '裁定驳回申请';
        case '5':
            return '解除非诉保全';
        case '255':
            return '其他';
    }
}

// 301240	非诉行为保全审查-当事人案件地位
export function typeFsxwbqscDsrajdw(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请人';
        case '2':
            return '被申请人';
    }
}

// 301250	非诉行为保全审查-行为保全事项
export function typeFsxwbqscXwbqsx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '中止支付信用证项下款项';
        case '2':
            return '中止支付保函项下款项';
        case '3':
            return '停止侵犯知识产权';
        case '4':
            return '海事强制令';
        case '5':
            return '申请责令被申请人作出一定行为';
        case '255':
            return '其他';
    }
}

// 301410	非诉行为保全复议-申请复议事项
export function typeFsxwbqfySqfysx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '裁定中止支付信用证项下款项裁定';
        case '2':
            return '裁定中止支付保函项下款项裁定';
    }
}

// 301420	非诉行为保全复议-是否诉中裁定
export function typeFsxwbqfySfszcd(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '是';
        case '2':
            return '否';
    }
}

// 301430	非诉行为保全复议-结案方式（裁定结果）
export function typeFsxwbqfyJafs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '维持';
        case '2':
            return '撤销原裁定并驳回钟会支付申请';
        case '3':
            return '按撤回复议申请处理';
        case '255':
            return '其他';
    }
}

// 301440	非诉行为保全复议-当事人案件地位
export function typeFsxwbqfyDsrajdw(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '复议申请人';
    }
}

// 301510	非诉证据保全审查-非诉期间
export function typeFszjbqscFsqj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '未起诉或提起仲裁前';
        case '2':
            return '仲裁审理期间';
        case '3':
            return '外国法院审理案件期间';
    }
}

// 301520	非诉证据保全审查-审查意见
export function typeFszjbqscScyj(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '裁定保全';
        case '2':
            return '裁定驳回申请';
        default:
            return '待裁定'
    }
}

// 301530	非诉证据保全审查-结案方式（裁定结果）
export function typeFszjbqscJafs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '裁定保全财产';
        case '2':
            return '裁定保全证据';
        case '3':
            return '裁定责令被申请人作出特定行为';
        case '4':
            return '裁定禁止被申请人作出特定行为';
        case '5':
            return '裁定驳回申请';
        case '6':
            return '准予撤回申请';
        case '255':
            return '其他';
        default:
            return '待裁定'
    }
}

// 301540	非诉证据保全审查-当事人案件地位
export function typeFszjbqscDsrajdw(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请人';
        case '2':
            return '被申请人';
    }
}

// 302000	是否续保
export function typeSfxb(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '是';
        case '2':
            return '否';
    }
}

// 303000	保全启动方式
export function typeBqqdfs(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '依申请';
        case '2':
            return '依职权';
    }
}

// 304000	保全类别
export function typeBqlb(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '诉前保全';
        case '2':
            return '诉讼保全';
        case '4':
            return '执行前保全';
    }
}

// 305000	保全状态
export function typeBqzt(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '待提交'
        case '2':
        case '10':
            return '待审核'
        case '3':
            return '补充材料'
        case '4':
            return '审核不通过'
        case '5':
            return '待交费'
        case '6':
            return '待裁定'
        case '7':
            return '已裁定'
        // case '8':
        //     return '审核中'
        case '9':
            return '已解除'
        case '11':
            return '已取消'
        case '12':
            return '已驳回'
        default:
            return ''
    }
}

// 401000	审判执行组织成员类型
export function typeSpzxzzcylx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '审判长';
        case '2':
            return '审判员';
        case '3':
            return '执行员';
        case '4':
            return '人民陪审员';
        case '5':
            return '法官助理';
        case '6':
            return '书记员';
        case '7':
            return '司法警察';
        case '8':
            return '技术调查官';
        case '255':
            return '其他';
    }
}

// 402000	审判执行组织成员是否承办人
export function typeSpzxzzcysfcbr(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '是';
        case '2':
            return '否';
    }
}

// 501000	法定代理人与当事人关系
export function typeFddlrydsrgx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '配偶';
        case '2':
            return '父母';
        case '3':
            return '子女';
        case '255':
            return '其他';
    }
}

//001 担保机构
export function BXGS(value) {
    value = String(value);
    switch (value) {
        case '001':
            return '中国人民财产保险股份有限公司';
        case '002':
            return '中国平安财产保险股份有限公司';
        case '003':
            return '众安在线财产保险股份有限公司'
    }
}

// 502000 单位
export function TDDW(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '平方米';
        case '2':
            return '公顷';
        case '3':
            return '平方千米';
    }
}

// 变更类型
export function bglxType(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '申请减小担保';
        case '2':
            return '申请变更担保';
        case '3':
            return '申请取消担保';
    }
}

// 304000	保全类型
export function typeBqlx(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '财产保全';
        case '2':
            return '证据保全';
        case '3':
            return '行为保全';
    }
}

// 土地单位
export function typeTddw(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '平方米';
        case '2':
            return '公顷';
        case '3':
            return '平方千米';
    }
}

// 担保情况
export function typeDbqk(value) {
    value = String(value);
    switch (value) {
        case "1":
            return "有担保";
        case "2":
            return "无担保";
        case "3":
            return "无需担保"
    }
}

// 保全解除审核结果
// export function typeJcjg(value) {
//     value = String(value);
//     switch (value) {
//         case "1":
//             return "审查通过";
//         case "2":
//             return "审查不通过";
//     }
// }
export function typeJcjg(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '通过';
        case '2':
            return '审查不通过';
        case '3':
            return '退回';
        default: return '审查中'
    }
}

//无需担保原因
export function typeWxdb(value){
    value = String(value);
    switch (value) {
        case "1":
            return "追索赡养费、抚养费、抚育费、抚恤金、医疗费用、劳动报酬、工伤赔偿、交通事故人身损害赔偿的";
        case "2":
            return "婚姻家庭纠纷案中遭遇家庭暴力且经济困难的";
        case "3":
            return "人民检察院提起的公益诉讼涉及损害赔偿的";
        case "4":
            return "因见义勇为遭受侵害请求损害赔偿的";
        case "5":
            return "案件事实清楚、权利义务关系明确，发生保全错误可能性较小的";
        case "6":
            return "申请保全人为商业银行、保险公司等由金融监管部门批准设立的具有独立偿付债务能力的金融机构及其分支机构的";
    }
}

// 804000 解除保全事由
export function typeJcbqsy(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '保全错误';
        case '2':
            return '申请人撤回保全申请';
        case '3':
            return '被申请人提供担保';
        case '255':
            return '应当解除保全的其他情形';
    }
}
// 823000 申请续保原因
export function typeSqxbyy(value) {
    value = String(value);
    switch (value) {
        case '1':
            return '保全期限到期';
        case '255':
            return '其他';
    }
}

//复议事项
export function typeFysx(value){
    value = String(value);
    switch (value) {
        case "1":
            return "财产保全审查的裁定";
        case "2":
            return "行为保全审查的裁定";
        case "3":
            return "证据保全审查的裁定";
    }
}

//复议案件类型
export function typeFyAjlx(value){
    value = String(value);
    switch (value) {
        case "1":
            return "刑事";
        case "2":
            return "民事";
        case "6":
            return "行政";
        case "12":
            return "非诉";
    }
}

//复议诉讼地位
export function typeSsdW(value){
    value = String(value);
    switch (value) {
        case "1":
            return "原申请人";
        case "2":
            return "原被申请人";
    }
}

//复议状态
export function typeFyzt(value){
    value = String(value);
    switch (value) {
        case "1":
            return "复议待提交";
        case "2":
            return "复议审核中";
        case "3":
            return "已复议";
        case "4":
            return "复议审核退回";
        case "5":
            return "待复议";
    }
}

//解保状态
export function typeJcbqZt(value){
    value = String(value);
    switch (value) {
        case "1":
            return "待提交";
        case "2":
            return "审查中";
        case "3":
            return "审查完成";
    }
}

//复议审核状态
export function typeFysh(value){
    value = String(value);
    switch (value) {
        case "1":
            return "通过";
        case "2":
            return "退回";
        case "3":
            return "退回";
    }
}

// 时间
export function typeTime(value) {
    if ("" != value && null != value) {
        /*let date = new Date(value);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let time = year + "-" + month + "-" + day;
        return time;*/
        return value
    }
    return "--";
}

//格式化时间
export function typeTime2(value){
    value = String(value);
    var year = value.substr(0, 4)
    var month = value.substr(5, 2)
    var day = value.substr(8, 2)
    return year + "-" + month + "-" + day
}

//复议 【裁定】 结果 诉前/诉讼保全复议
export function fyjgType(value){
    value = Number(value)
    switch (value) {
        case 1:
            return '驳回复议申请'
        case 2:
            return '撤销原裁定并驳回原申请'
        case 3:
            return '撤销原裁定并支持原申请'
        case 4:
            return '变更原裁定'
        case 5:
            return '准予撤回复议申请'
        case 6:
            return '按撤回复议申请处理'
        case 255:
            return '其他'
        default: return '--'
    }
}

//诉前 行为保全复议
export function typeSqxwfy(value){
    value = Number(value)
    switch (value) {
        case 1:
            return '维持'
        case 2:
            return '撤销原裁定并驳回中止支付申请'
        case 3:
            return '准予撤回复议申请'
        case 4:
            return '按撤回复议申请处理'
        case 255:
            return '其他'
        default: return '--'
    }
}

//证据类型
export function zjlxType(value){
    value = Number(value)
    switch (value) {
        case 1:
            return '当事人陈述'
        case 2:
            return '被告人陈述'
        case 3:
            return '犯罪嫌疑人、被告人供述和辩解'
        case 4:
            return '书证'
        case 5:
            return '物证'
        case 6:
            return '视听资料'
        case 7:
            return '电子数据'
        case 8:
            return '证人证言'
        case 9:
            return '鉴定意见'
        case 10:
            return '勘验、检查、辨认、侦查实验等笔录'
        case 255:
            return '其他'
        default: return '--'
    }
}

//行为保全事项
export function xwsxType(value){
    value = Number(value)
    switch (value) {
        case 1:
            return '中止支付信用证项下款项'
        case 2:
            return '中止支付保函项下款项'
        case 3:
            return '停止侵犯知识产权'
        case 5:
            return '申请责令被申请人作出一定行为'
        case 255:
            return '其他'
        default: return '--'
    }
}

//解保原因
export function jbyyType(value){
    value = Number(value)
    switch (value) {
        case 1:
            return '被申请人提供担保'
        case 2:
            return '人民法院已受理对被申请人的破产申请'
        case 3:
            return '复议撤销了保全'
        case 5:
            return '当事人提出解除保全申请'
        case 255:
            return '其他'
        default: return '--'
    }
}

export function accAdd(data1, data2) {
    var r1, r2, m, c;
    try {  r1 = data1.toString().split(".")[1].length;}catch (e) {  r1 = 0; }
    try { r2 = data2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            data1= Number(data1.toString().replace(".", ""));
            data2= Number(data2.toString().replace(".", "")) * cm;
        } else {
            data1= Number(data1.toString().replace(".", "")) * cm;
            data2= Number(data2.toString().replace(".", ""));
        }
    } else {
        data1= Number(data1.toString().replace(".", ""));
        data2= Number(data2.toString().replace(".", ""));
    }
    return (data1+ data2) / m;
}


// 担保情况
export function dbqkType(value){
    value = String(value);
    switch (value) {
        case '1':
            return '有担保';
        case '2':
            return '无担保';
        case '3':
            return '无需担保';
        default: return '--'
    }
}

// 原件原物
export function yjwjType(value){
    value = String(value);
    switch (value) {
        case '1':
            return '是';
        case '2':
            return '否';
        default: return '--'
    }
}
